import styled from 'styled-components';
import Indicator_01 from '../../assets/area/safety/indicator_01.svg';
import Indicator_02 from '../../assets/area/safety/indicator_02.svg';

export const DeathsIcon = styled(Indicator_02)`
  scale: 80%;
`;
export const MurdersIcon = styled(Indicator_01)`
  scale: 80%;
`;
